import { Box } from "@mui/system";
import EarningsTabs from "./EarningsTabs";

const Earnings = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <EarningsTabs />
      </Box>
    </>
  );
};

export default Earnings;
